import React from 'react';
export function GuaranteeSection() {
  return <section className="section-card" data-id="element-69">
      <div className="max-w-3xl mx-auto" data-id="element-70">
        <div className="bg-gradient-to-br from-yellow-400/20 to-yellow-600/20 backdrop-blur-sm border-2 border-yellow-400/50 rounded-2xl p-8 md:p-12 text-center shadow-2xl" data-id="element-71">
          <div className="w-20 h-20 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg" data-id="element-72">
            <svg className="w-10 h-10 text-gray-900" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-73">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-74" />
            </svg>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-75">
            Garantía de Paz Interior
          </h2>

          <div className="text-yellow-300 font-bold text-xl mb-6" data-id="element-76">
            7 Días Sin Riesgo
          </div>

          <p className="text-lg text-blue-100 leading-relaxed mb-6" data-id="element-77">
            Si después de 7 días no sientes más calma, claridad o conexión con
            tu fe, te devolvemos el 100% de tu dinero. Sin preguntas. Sin
            complicaciones.
          </p>

          <p className="text-white font-semibold text-xl" data-id="element-78">
            Tu transformación espiritual está garantizada.
          </p>

          <div className="mt-8 pt-6 border-t border-yellow-400/30" data-id="element-79">
            <p className="text-blue-200 text-sm" data-id="element-80">
              Creemos tanto en este método que asumimos todo el riesgo por ti.
            </p>
          </div>
        </div>
      </div>
    </section>;
}